import React, { useState } from 'react'
import CardCustom from '../../components/card'
import TableMaterial from '../../components/tableMaterial/tableMaterial'
import useFetchTransactionsByUser from '../../service/userTransactions/getTransaction';
import { useGetChargeBackQuery } from '../../service/userTransactions/getChargeBack';
import { TableCustomProps } from '../../components/table/table';
import { PaymentIcon } from 'react-svg-credit-card-payment-icons';
import { formatToMexicanPesos } from '../../utils/format';
import ButtonUI from '../../components/button/buttons';
import HelpIcon from "@mui/icons-material/Help";

const CanceledTransaction = () => {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endStarDate, setEndStartDate] = useState<Date | null>(null);
  const [selectedTransaction, setSelectTransaction] = useState<null>(null);
  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [status, setStatus] = useState("cancelled");

  const handleOpenModal = (transaction: any) => {
    setOpenModal(true);
    setSelectTransaction(transaction);
  };


    const transformDataToTable = (
    transactions: any[]
  ): TableCustomProps["rows"] => {

    return transactions.map((transaction) => ({

      name: transaction.full_name,
      company: (
        <PaymentIcon
          type={transaction.card_brand}
          format="flatRounded"
          width={36}
        />
      ),
      activity: transaction.status_description,
      email: transaction.email,
      amount: formatToMexicanPesos(transaction.amount) ,
      comision: transaction?.comission ?  formatToMexicanPesos(transaction?.comission?.api_commission?.commission ): formatToMexicanPesos(transaction?.amount_with_comision),
      //country: transaction.currency,
      date: new Date(transaction?.created_at).toLocaleDateString("es-MX", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Mexico_City",
      }),
      //status: (<StatusLabel value={transaction.status} />),

      info: (
        <div>
          <ButtonUI
            icon={<HelpIcon />}
            variant="text"
            onClick={() => handleOpenModal(transaction)}
          />
        </div>
      ),
    }));
  };





  const { data, error, isLoading } = useGetChargeBackQuery({
    page: page,
    pageSize: rowsPerPage,
    email: email || undefined,
    status: status || undefined,
    dateFrom: startDate ? startDate.toISOString() : undefined,
    dateTo: endStarDate ? endStarDate.toISOString() : undefined,
  });




  const onChangeEmail = (e: any) => {
    setEmail(e.target.value);
  };

  const handleSearchClick = () => {
    setSearchClicked((prev) => !prev);
  };

  const onClickCleanFilters = () => {
    setEndStartDate(null);
    setStartDate(null);
    setStatus("ALL");
    setEmail("");
  };


      const dataTable: any = {
    columns: [
      { id: "name", label: "Nombre" },
      { id: "company", label: "Banco" },
      { id: "activity", label: "Respuesta de banco" },
      { id: "email", label: "Correo" },
      { id: "amount", label: "Pago" },
      { id: "comision", label: "Comision" },
      //{ id: "country", label: "Moneda" },
      { id: "date", label: "Fecha" },
      { id: "status", label: "Estado" },
      { id: "info", label: "Info" },
    ],
    rows: transformDataToTable(  data?.response?.data || []),
  };

  return (
    <div>
      <CardCustom>
        <h2>
          Contracargos
        </h2>
        <TableMaterial
          id="table-reportes"
          isClean={true}
          //setStatus={setStatus}
          //status={status}
          onClickFilters={onClickCleanFilters}
          valueInput={email}
          onClickSearch={handleSearchClick}
          onChangeInput={onChangeEmail}
          isDate={true}
          setEndDate={setEndStartDate}
          setStartDate={setStartDate}
          startDate={startDate}
          endDate={endStarDate}
          totalRows={data?.response?.pagination?.countData}
          setPage={setPage}
          page={page}
          setRowsPerPage={setRowsPerPage}
          rowsPerPage={rowsPerPage}
          report={true}
          columns={dataTable.columns}
          rows={dataTable?.rows || []}
          loading={isLoading}
          isSearch={true} 
        />

      </CardCustom>
    </div>
  )
}

export default CanceledTransaction